module.exports = __webpack_public_path__ + "img/modern_shop_thumbnail-400x300.9ed1d259.jpg";